if (window.location.pathname == "/") {
    const content = document.querySelector(".content");
    content.classList.remove("background");
  };